export default __webpack_public_path__ + "static/flexible-a44105210349a42e716ce502b9a98277.jpg";